import { require } from 'ace-builds';
import React, { useContext, useEffect, useRef, useState } from 'react';

import GoogleLogin from 'react-google-login';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Footer from './comps/footer';
import './styles/auth.css'
import Axios from 'axios'
import { ENDPOINT, makeDraggable, ShowNotification } from '../utils/constants';
import Cookie from 'js-cookie'
import { Context } from '../context';
import { notifyRef } from './refs';

export default function Auth() {

    const context = useContext(Context)

    const responseSuccessGoogle = (response) => {
        console.log(response)
        Axios.post(ENDPOINT + '/auth/google', { tokenId: response.tokenId })
            .then(res => {
                if (res.data.success) {
                    const { token } = res.data
                    Cookie.set('token', token, { expires: 100 })
                    context.setIsLogedIn(true)
                }
            })
            .catch(err => {
                ShowNotification('Something went wrong', 'red', -1)
            })
    }

    const responseErrorGoogle = (response) => {
        ShowNotification('Something went wrong', 'red', -1)
    }




    const tesCaseRef = useRef(null)
    const [showTestcase, setShowTestCase] = useState(false)
    useEffect(() => {

        makeDraggable("auth-pc")


        setTimeout(() => {
            try {
                document.getElementById("submit").click()
            } catch (err) {

            }
        }, 1000 * 20);
    }, [])

    return (
        <>
            <div className="auth-wrapper">
                <div className="auth-left">

                    <h1 className="auth-title" data-aos="fade-right" data-aos-duration="1000" id="title">CodeFreak</h1>

                    <div className="auth-glogin-wrapper" data-aos="zoom-in" data-aos-duration="1000">
                        <GoogleLogin
                            clientId="432827620544-30kf3nvnnqtadjuqd9as4l92j0qam71f.apps.googleusercontent.com"
                            buttonText="Login"
                            onSuccess={responseSuccessGoogle}
                            onFailure={responseErrorGoogle}
                            cookiePolicy={'single_host_origin'}
                            redirectUri="https://codefreak.netlify.app/"
                            // redirectUri="http://localhost:3000/"

                            render={renderProps => (
                                <div onClick={renderProps.onClick} disabled={renderProps.disabled} className="auth-glogin" >Sigin/Signup with Google</div>
                            )}
                        />
                    </div>
                </div>

                <div className='auth-right'>
                    <div className="auth-pc-wrapper" data-aos="zoom-in" data-aos-duration="1000" id="auth-pc">
                        <div class="css-typing" autoCorrect={false} data-aos="zoom-in">
                            <p>
                                <span style={{ color: "#C42483" }}>def</span> <span style={{ color: "#1A87E5" }}>detectCycle(<span style={{ color: 'white' }}>head</span>)</span>:
                        </p>
                            <p>
                                hare, tortoise <span style={{ color: "#1A87E5" }}>=</span> head, head
                        </p>
                            <p>
                                <span style={{ color: '#1A87E5' }}>while</span> tortoise <span style={{ color: "#1A87E5" }}>!= </span>None <span style={{ color: 'red' }}>and</span> hare <span style={{ color: "#1A87E5" }}>!=</span> None <span style={{ color: 'red' }}>or</span> hare <span style={{ color: "#1A87E5" }}>!= </span> tortoise:
                            </p>
                            <p>
                                <span style={{ color: 'white' }}>hare, tortoise</span> <span style={{ color: "#1A87E5" }}>= </span> hare.next.next, tortoise.next
                            </p>
                            <p>
                                <span style={{ color: '#1A87E5' }}>return</span> tortoise
                            </p>
                        </div>
                        <div className="sol-submission-wrapper">
                            <div className="lds-dual-ring" id="loader" style={{ borderWidth: 0 }}></div>
                            <div>Run</div>
                            <div onClick={() => {
                                tesCaseRef.current.innerHTML = '. . . . . .'
                                document.getElementById("loader").style.display = 'block'
                                setShowTestCase(false);

                                setTimeout(() => {
                                    try {
                                        tesCaseRef.current.innerHTML = 'Submit'
                                        document.getElementById("loader").style.display = 'none'
                                        setShowTestCase(true);
                                        // makeDraggable('auth-testcase')
                                    } catch (err) { }
                                }, 2000)
                            }} ref={tesCaseRef} id="submit">
                                Submit
                            </div>
                        </div>
                        {
                            showTestcase &&
                            <div className="auth-testcase-2" data-aos="zoom-in"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine" id="auth-testcase">
                                <div></div>
                                <div><span>Testcase 0</span></div>
                                <div><span>Testcase 1</span></div>
                                <div><span>Testcase 2</span></div>
                                <div><span style={{ color: 'brown' }}>Testcase 3</span></div>
                                <div><span>Testcase 4</span></div>
                                <div><span style={{ color: 'brown' }}>Testcase 5</span></div>
                                <div><span>Testcase 6</span></div>
                                <div><span>Testcase 7</span></div>
                                <div><span>Testcase 8</span></div>
                                <div><span style={{ color: 'brown' }}>Testcase 9</span></div>
                                <div><span>Testcase 10</span></div>
                            </div>
                        }
                    </div>
                    {/* {
                        showTestcase &&
                        <div className="auth-testcase" data-aos="zoom-in"
                            data-aos-offset="300"
                            data-aos-easing="ease-in-sine" id="auth-testcase">
                            <div></div>
                            <div><span>Testcase 0</span></div>
                            <div><span>Testcase 1</span></div>
                            <div><span>Testcase 2</span></div>
                            <div><span style={{ color: 'brown' }}>Testcase 3</span></div>
                            <div><span>Testcase 4</span></div>
                            <div><span style={{ color: 'brown' }}>Testcase 5</span></div>
                            <div><span>Testcase 6</span></div>
                            <div><span>Testcase 7</span></div>
                            <div><span>Testcase 8</span></div>
                            <div><span style={{ color: 'brown' }}>Testcase 9</span></div>
                            <div><span>Testcase 10</span></div>

                        </div>
                    } */}
                </div>
            </div>
            <Footer />
            <div className="notif" ref={notifyRef} id="notif">
                <span id="notif-text"></span>
            </div>
        </>
    )
}